module.exports = __webpack_public_path__ + "av.no2.87a43f81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/av.no2.jpg
// module id = 1cy/
// module chunks = 0